<template>
    <div>
        <card-header :title="user.first_name + 's ' + 'Support Ticket List'" icon="fa-life-ring"/>

        <card-toolbar>
            <button @click="openCard('support-ticket-new')"><i class="far fa-envelope-open-text"></i>New Ticket</button>

            <template v-slot:right>
                <button class="icon-only" @click="openCard('support-settings')"><i class="far fa-cog"></i></button>
            </template>
        </card-toolbar>

        <card-body toolbar>
            <card-list>
                <support-ticket-list-item @action="openCard('support-message')"/>

                <support-ticket-list-item/>

                <support-ticket-list-item/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import SupportTicketListItem from "../../components/SupportTicketListItem";
    import CardToolbar from "../../components/common/CardToolbar";

    export default {
        components: {
            CardHeader, CardBody, CardList, SupportTicketListItem, CardToolbar
        },

        methods: {
            chooseEnrollment: function() {
                console.log('chooseEnrollment');
                this.$store.commit('openCard', {card: 'enrollment-summary', props: {}});
            },

            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            },
        },

        data(){
            return {
                user: {
                    id: 249,
                    first_name: 'Scott',
                    last_name: 'Lamont'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
